// extracted by mini-css-extract-plugin
export var cardContent = "CaseStudy-module--cardContent--9d0bc";
export var description = "CaseStudy-module--description--a0dbf";
export var extra = "CaseStudy-module--extra--068b6";
export var image = "CaseStudy-module--image--d7818";